import { render } from "./PropertySearch.vue?vue&type=template&id=5b50d5d0"
import script from "./PropertySearch.vue?vue&type=script&lang=js"
export * from "./PropertySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__